import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, isExpired, endSession } from '../auth/session';

/**
 * Wraps protected routes.
 *   - no token            → /login
 *   - token past expiry   → session cleared, → /session-expired
 *   - otherwise           → renders children
 *
 * Usage: <PrivateRoute><DashboardPage /></PrivateRoute>
 *
 * LoginPage stores `tokenExpiry` at sign-in. Checking it here stops an expired
 * session at the door rather than letting a page load and then fail on a 401.
 * This is a route-entry check only — SessionTimeout covers idle sessions and the
 * axiosConfig 401 interceptor covers everything else.
 *
 * The storage details live in shared/auth/session.js, which is also what makes
 * the expiry check tolerant of sessions created before it shipped.
 */
function PrivateRoute({ children }) {
  if (!isAuthenticated()) return <Navigate to="/login" replace />;

  if (isExpired()) {
    endSession();
    return <Navigate to="/session-expired" replace />;
  }

  return children;
}

export default PrivateRoute;
